import { render, staticRenderFns } from "./ProductAccessPeriodList.vue?vue&type=template&id=34e8ab88&scoped=true&"
import script from "./ProductAccessPeriodList.vue?vue&type=script&lang=ts&"
export * from "./ProductAccessPeriodList.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAccessPeriodList.vue?vue&type=style&index=0&id=34e8ab88&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e8ab88",
  null
  
)

export default component.exports